export const FlagBR = ({ className = "h-4 w-6" }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <rect width="24" height="16" rx="2" fill="#009B3A" />
    <polygon points="12,2.5 21,8 12,13.5 3,8" fill="#FEDF00" />
    <circle cx="12" cy="8" r="3" fill="#002776" />
  </svg>
);

export const FlagUS = ({ className = "h-4 w-6" }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <rect width="24" height="16" rx="2" fill="#B22234" />
    <rect y="1.85" width="24" height="1.85" fill="#fff" />
    <rect y="5.55" width="24" height="1.85" fill="#fff" />
    <rect y="9.25" width="24" height="1.85" fill="#fff" />
    <rect y="12.95" width="24" height="1.85" fill="#fff" />
    <rect width="10" height="8.6" rx="1.5" fill="#3C3B6E" />
    <circle cx="2.5" cy="2.2" r="0.6" fill="#fff" />
    <circle cx="5" cy="2.2" r="0.6" fill="#fff" />
    <circle cx="7.5" cy="2.2" r="0.6" fill="#fff" />
    <circle cx="3.7" cy="4.2" r="0.6" fill="#fff" />
    <circle cx="6.2" cy="4.2" r="0.6" fill="#fff" />
    <circle cx="2.5" cy="6.2" r="0.6" fill="#fff" />
    <circle cx="5" cy="6.2" r="0.6" fill="#fff" />
    <circle cx="7.5" cy="6.2" r="0.6" fill="#fff" />
  </svg>
);

export const FlagES = ({ className = "h-4 w-6" }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <rect width="24" height="16" rx="2" fill="#AA151B" />
    <rect y="4" width="24" height="8" fill="#F1BF00" />
    <rect x="5.5" y="6" width="2.5" height="4" rx="1" fill="#AA151B" />
  </svg>
);
